import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CartService } from '../../services/cart.service';
import { MENU_ITEMS } from '../../config/menu.config';
import { Role } from '../../models/role.model';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {
  cartItemCount: number = 0;
  menuItems: any[] = [];

  isLoggedIn = false;
  userRole: string | null = null;

  constructor(public auth: AuthService, private router: Router, private cartService: CartService) {
  }


  logout(): void {
    this.auth.logout();
    // Reset cart item count
    this.cartItemCount = 0;

    this.router.navigateByUrl('/login');
  }


  ngOnInit(): void {

    this.auth.isLoggedIn();

    this.auth.loggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });

    this.auth.userRole$.subscribe(role => {
      this.userRole = role;
      this.menuItems = role ? MENU_ITEMS[role as Role] || [] : [];
    });

    //const role = this.auth.getUserRole() as Role | null;
    //this.menuItems = role ? MENU_ITEMS[role] || [] : [];

    if (!this.auth.isTokenExpired()) {
      this.cartService.cartItemCount$.subscribe(count => {
        this.cartItemCount = count;
      });
    }
    else {
      this.router.navigateByUrl('/');
    }
  }


}
